import React from 'react';

const PrintableTableRaw = ({
                             rowData = [],
                             columnDefs = [],
                             formatters = {},
                             className = ""
                           }) => {
  if (!columnDefs.length || !rowData.length) return null;
  const headers = columnDefs.map(def => {
    return {
      header: def.printableTableAlias ? def.printableTableAlias : def.headerName,
      field: def.field,
      flex: def.flex ?? 1
    };
  });
  const totalFlex = headers.reduce((acc, col) => acc + col.flex, 0);

  const headersWithWidth = headers.map(col => ({
    ...col,
    width: totalFlex > 0 ? `${(col.flex / totalFlex) * 100}%` : 'auto'
  }));
  const renderCell = (field, row) => {
    if (!field) return "";

    if (formatters[field]) {
      return formatters[field](row);
    }

    return row[field];
  };

  return (
    <table className={["print:table border border-[#e0e1e3] border-collapse table-fixed text-[14px]", className].join(" ")}>
      <thead className="w-[100%] ">
      <tr>
        {headersWithWidth.map((h, index) => (
          <th
            key={h.field || `header-${index}`}
            style={{ width: h.width }}
            className="p-2 bg-[#efefef] border border-[#e0e1e3] border-collapse text-start"
          >
            {h.header}
          </th>
        ))}
      </tr>
      </thead>

      <tbody>
      {rowData.map((row, i) => (
        <tr key={i}>
          {headers.map((h, colIndex) => (
            <td
              key={h.field || `cell-${colIndex}`}
              className={[i % 2 === 0 ? 'bg-white' : 'bg-[#efefef]', ' p-1 border border-[#e0e1e3] border-collapse'].join(" ")}
            >
              {renderCell(h.field, row)}
            </td>
          ))}
        </tr>
      ))}
      </tbody>
    </table>
  );
};

export default PrintableTableRaw;